import {
  Box,
  Button,
  Heading,
  HStack,
  Image,
  Text,
  VStack,
  SimpleGrid,
  useDisclosure
} from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { ActionModal, Layout, Terms } from '../../../components'
import { ROUTES } from '../../../contants'
import useMotorStore from '../../../state/Motor.store'
import { money } from '../../../utils/formatter'
import { screens } from './types'

const MotorSummary = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [
    vehicleDetails,
    policy,
    setScreen,
    generateAccount,
    loading,
    policy_number,
    errorMessage,
    setErrorMsg
  ] = useMotorStore((state) => [
    state.vehicleDetails,
    state.policy,
    state.setScreen,
    state.generateAccount,
    state.loading,
    state.policy_number,
    state.errorMessage,
    state.setErrorMsg
  ])
  const { isOpen: modalIsOpen, onOpen: modalOnOpen, onClose: modalOnClose } = useDisclosure()

  useEffect(() => {
    setErrorMsg('')
  }, [setErrorMsg])

  useEffect(() => {
    if (errorMessage != '') {
      modalOnOpen()
    } else {
      modalOnClose()
    }
  }, [errorMessage, modalOnOpen, modalOnClose])

  const submit = async () => {
    try {
      onClose()
      await generateAccount()
      setScreen(screens.MOTOR_PAYMENT)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Layout previous={() => setScreen(screens.MOTOR_POLICY)} title="Summary">
      <ActionModal error message={errorMessage} isOpen={modalIsOpen} onClose={modalOnClose} />
      <Box flex={1}>
        {/* <BaseHeading title="Your Premium" /> */}

        <Text fontSize="1.2rem">
          Please ensure all vehicle details are correct before proceeding to make payment{' '}
        </Text>

        <Box
          mb="2rem"
          mt="2.4rem"
          borderRadius="1.2rem"
          overflow="hidden"
          border="1px dashed #0AB86F">
          <Image my="3.2rem" mx="auto" maxW="181px" src="/images/car.png" />

          <Box px="3.2rem" pt="3.2rem">
            <SimpleGrid pb="3.2rem" borderBottom="1px solid #B2B2B2" columns={2} spacing={10}>
              <VStack align="flex-start">
                <Text fontSize="1rem">Brand/Model</Text>
                <Text color="black" fontWeight="500" fontSize="1.2rem">
                  {`${vehicleDetails.make} / ${vehicleDetails.model}`}
                </Text>
              </VStack>
              <VStack align="flex-end">
                <Text fontSize="1rem">Year</Text>
                <Text color="black" fontWeight="500" fontSize="1.2rem">
                  {vehicleDetails.year || '-'}
                </Text>
              </VStack>

              <VStack align="flex-start">
                <Text fontSize="1rem">Policy Number</Text>
                <Text color="black" fontWeight="500" fontSize="1.2rem">
                  {policy_number || '-'}
                </Text>
              </VStack>
              <VStack align="flex-end">
                <Text fontSize="1rem">Vehicle Plate Number</Text>
                <Text color="black" fontWeight="500" fontSize="1.2rem">
                  {vehicleDetails.plate_number.toUpperCase()}
                </Text>
              </VStack>
            </SimpleGrid>
          </Box>
          <HStack justify="space-between" bg="rgba(223, 246, 240, 0.2)" py="1.3rem" px="3rem">
            <HStack>
              <Image mr="1.2rem" src="/images/shield.svg" />
              <Text color="brand.blue">{policy.name}</Text>
            </HStack>
            <VStack align="flex-start">
              <Heading color="brand.blue">{money(policy.value)}</Heading>
              <Text fontSize="1rem" color="black">
                per {policy.period}
              </Text>
            </VStack>
          </HStack>
        </Box>
      </Box>
      <Button isDisabled={!policy_number} isLoading={loading} onClick={onOpen} variant="green">
        Proceed to Pay {money(policy.value)}
      </Button>

      <Terms onClick={submit} onClose={onClose} isOpen={isOpen} />
    </Layout>
  )
}

export { MotorSummary }
